import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppFacade } from './+state/app.facade';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './+state/app.effects';
import { StoreModule } from '@ngrx/store';
import * as fromApp from './+state/app.reducer';
import { CFB_INTEGRATION_STATE_PROVIDER } from './cfb-integration-state.provider';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([AppEffects]),
    StoreModule.forFeature(fromApp.APP_FEATURE_KEY, fromApp.appReducer),
  ],
  providers: [AppFacade, CFB_INTEGRATION_STATE_PROVIDER],
})
export class CignaForBrokersSharedDataAccessModule {}
